import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useState, useEffect } from 'react';
import { Menu, X } from 'lucide-react';
import LogoFull from '../ui/logo-full';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navItems = [
    { label: 'Suite', desc: 'Core capabilities, perfected', href: '/features' },
    { label: 'Assessments', desc: 'Assessments that actually assess', href: '/assessments' },
    { label: 'Intelligence', desc: 'AI that thinks like you do', href: '/ai-matching' },
    { label: 'Interviews', desc: 'Where great interviews happen', href: '/interviews' },
    { label: 'About', desc: 'Where great interviews happen', href: '/about' },

    { label: 'Contact Sales', desc: 'Plans for the ambitious', href: '/contact' },
  ];

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-white/90 backdrop-blur-xl border-b border-neutral-200' : 'bg-transparent'
        }`}
    >
      <div className="container mx-auto px-6 lg:px-12">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <Link to="/" className="flex items-center gap-3">
            <LogoFull />
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden xl:flex items-center gap-1">
            {navItems.map((item) => (
              item.external ? (
                <a
                  key={item.label}
                  href={item.external}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="px-4 py-2 font-medium text-sm transition-colors duration-200 text-neutral-500 hover:text-black"
                >
                  {item.label}
                </a>
              ) : (
                <Link
                  key={item.label}
                  to={item.href}
                  className={`px-4 py-2 font-medium text-sm transition-colors duration-200 ${location.pathname === item.href
                    ? 'text-black'
                    : 'text-neutral-500 hover:text-black'
                    }`}
                >
                  {item.label}
                </Link>
              )
            ))}
          </nav>

          {/* CTA Buttons */}
          <div className="hidden xl:flex items-center gap-6">

            <a href='https://app.sandgen.com/admin/login' target='_blank' className="btn-primary text-sm px-6 py-2.5">
              Experience Sandgen
            </a>
          </div>

          {/* Mobile Menu Button */}
          <button
            className="xl:hidden text-black p-2"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          >
            {isMobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <div className="xl:hidden bg-white border-t border-neutral-100 py-6">
            <nav className="flex flex-col gap-1">
              {navItems.map((item) => (
                item.external ? (
                  <a
                    key={item.label}
                    href={item.external}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="px-4 py-3 font-medium transition-colors rounded-lg text-neutral-600 hover:text-black hover:bg-neutral-50"
                    onClick={() => setIsMobileMenuOpen(false)}
                  >
                    {item.label}
                  </a>
                ) : (
                  <Link
                    key={item.label}
                    to={item.href}
                    className={`px-4 py-3 font-medium transition-colors rounded-lg ${location.pathname === item.href
                      ? 'text-black bg-neutral-50'
                      : 'text-neutral-600 hover:text-black hover:bg-neutral-50'
                      }`}
                    onClick={() => setIsMobileMenuOpen(false)}
                  >
                    {item.label}
                  </Link>
                )
              ))}
              <div className="border-t border-neutral-100 mt-4 pt-4 px-4 flex flex-col gap-3">
                <a href="https://app.sandgen.com/admin/login" target='_blank' className="btn-primary w-full text-center" onClick={() => setIsMobileMenuOpen(false)}>Experience Sandgen</a>
              </div>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;